import store from '../store'
import { sidebarLayer } from '../config/project.config'
import DefaultLayout from '../views/layout/DefaultLayout.vue'

const _import = require('./' + process.env.NODE_ENV + '.js')

// meta 对象字段信息
// category： 路由分类，
// baseCategory：所属类目，
// title: 路由标题，
// hidden: 是否在导航中显示，
// icon：图标
// activeIcon：active图标
// rightName: 与后端约定的权限code
// permissions：所属的权限类目，限定路由的所属权限 list从project.config.js导入
// sidebarLayer: sidebar层级,控制导航显示的层次 从project.config.js导入

export const authRouterList = [
  {
    path: '/',
    name: 'DefaultLayout',
    component: DefaultLayout,
    redirect: () => {
      return {
        name: store.getters.indexRouter,
      }
    },
    children: [
      {
        path: 'campus',
        name: 'campusManage',
        component: _import('campus/CampusManage'),
        meta: {
          title: 'campus.manage',
          category: 'campus',
          rightName: '学习中心',
          sidebarLayer: sidebarLayer.superLayer,
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'campusList',
        },
        children: [
          {
            path: 'list',
            name: 'campusList',
            component: _import('campus/CampusList'),
            meta: {
              title: 'campus.allCampus',
              category: 'campus',
              rightName: '所有学习中心',
              sidebarLayer: sidebarLayer.superLayer,
              // icon: require('../assets/img/icon/所有校区.png')
            },
          },
        ],
      },
      {
        path: 'staff',
        name: 'staffManage',
        component: _import('staff/StaffManage'),
        meta: {
          title: 'staff.manage',
          category: 'staff',
          rightName: '员工管理',
          sidebarLayer: sidebarLayer.superLayer,
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'staffList',
        },
        children: [
          {
            path: 'list',
            name: 'staffList',
            component: _import('staff/StaffList'),
            meta: {
              title: 'staff.allStaff',
              category: 'staff',
              rightName: '所有员工',
              sidebarLayer: sidebarLayer.superLayer,
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
          {
            path: 'department',
            name: 'departmentList',
            component: _import('staff/DepartmentList'),
            meta: {
              title: 'staff.allDepartment',
              category: 'staff',
              rightName: '权限',
              sidebarLayer: sidebarLayer.superLayer,
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
          {
            path: 'Subjects',
            name: 'Subjects',
            component: _import('staff/Subjects'),
            meta: {
              title: 'staff.subject',
              category: 'staff',
              rightName: '学科编辑',
              sidebarLayer: sidebarLayer.superLayer,
            },
          },
        ],
      },

      {
        path: 'week',
        name: 'weekManage',
        component: _import('week/weekManage'),
        meta: {
          title: 'week.acedemicWeek',
          category: 'week',
          rightName: '学术周',
          sidebarLayer: sidebarLayer.superLayer,
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'weekList',
        },
        children: [
          {
            path: 'weekList',
            name: 'weekList',
            component: _import('week/weekList'),
            meta: {
              title: 'week.acedemicWeek',
              category: 'week',
              rightName: '所有学术周',
              sidebarLayer: sidebarLayer.superLayer,
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
        ],
      },

      //
      {
        path: 'message',
        name: 'message',
        component: _import('approvals/ApprovalsManage'),
        meta: {
          title: 'public.messageCenter',
          category: 'message',
          rightName: '成绩审批',
          sidebarLayer: sidebarLayer.superLayer,
        },
        redirect: () => {
          return {
            name: 'approvalsList',
          }
        },
        children: [
          {
            path: 'approvalsList',
            name: 'approvalsList',
            component: _import('approvals/Approval'),
            meta: {
              title: 'public.approval',
              category: 'message',
              rightName: '待审批',
              sidebarLayer: sidebarLayer.superLayer,
              tag: 'toCheckCnt',
            },
          },
          {
            path: 'approvalsRecord',
            name: 'approvalsRecord',
            component: _import('approvals/Record'),
            meta: {
              title: 'public.recordr',
              category: 'message',
              rightName: '已审批',
              sidebarLayer: sidebarLayer.superLayer,
            },
          },
          {
            path: 'approvalsNotice',
            name: 'approvalsNotice',
            component: _import('approvals/Notice'),
            meta: {
              title: 'public.notice',
              category: 'message',
              rightName: '通知',
              sidebarLayer: sidebarLayer.superLayer,
              tag: 'noReadCount',
            },
          },
        ],
      },
      {
        path: 'class',
        name: 'classManage',
        component: _import('class/ClassManage'),
        meta: {
          title: 'class.manage',
          category: 'class',
          rightName: '班级管理',
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'classList',
        },
        children: [
          {
            path: 'list',
            name: 'classList',
            component: _import('class/ClassList'),
            meta: {
              title: 'class.allClass',
              category: 'class',
              rightName: '所有班级',
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
        ],
      },
      //

      {
        path: 'student',
        name: 'studentManage',
        component: _import('student/StudentManage'),
        meta: {
          title: 'student.manage',
          category: 'student',
          rightName: '学生管理',
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'studentList',
        },
        children: [
          {
            path: 'list',
            name: 'studentList',
            component: _import('student/StudentList'),
            meta: {
              title: 'student.allStudent',
              category: 'student',
              rightName: '所有学生',
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
        ],
      },
      {
        path: 'timetable',
        name: 'timetableManage',
        component: _import('timetable/TimetableManage'),
        meta: {
          title: 'timetable.manage',
          category: 'timetable',
          rightName: '课表管理',
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'teacherTimetableList',
        },
        children: [
          {
            path: 'teacher',
            name: 'teacherTimetableList',
            component: _import('timetable/TeacherTimetableList'),
            meta: {
              title: 'timetable.teacherTimetable',
              category: 'timetable',
              rightName: '老师课表',
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
          {
            path: 'class',
            name: 'classTimetableList',
            component: _import('timetable/ClassTimetableList'),
            meta: {
              title: 'timetable.classTimetable',
              category: 'timetable',
              rightName: '班级课表',
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
        ],
      },
      {
        path: 'grades',
        name: 'gradesManage',
        component: _import('grades/GradesManage'),
        meta: {
          title: 'grades.manage',
          category: 'grades',
          rightName: '成绩',
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'gradesSwitch',
        },
        children: [
          {
            path: 'gradesSwitch',
            name: 'gradesSwitch',
            component: _import('grades/gradesSwitch'),
            meta: {
              title: 'grades.regularGrades',
              category: 'grades',
              rightName: '平时成绩',
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
          // {
          //   path: 'regular',
          //   name: 'regularGrades',
          //   component: _import('grades/RegularGrades'),
          //   meta: {
          //     title: 'grades.regularGrades',
          //     category: 'grades',
          //     rightName: '平时成绩'
          //     // icon: require('../assets/img/icon/所有机构.png')
          //   }
          // },
          {
            path: 'term',
            name: 'termGrades',
            component: _import('grades/TermGrades'),
            meta: {
              title: 'grades.termGrades',
              category: 'grades',
              rightName: '科目成绩',
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
          {
            path: 'term/:classId',
            name: 'termGradesClass',
            component: _import('grades/TermGradesClass'),
            meta: {
              hidden: true,
              baseName: 'termGrades',
              title: 'grades.termGrades',
              category: 'grades',
              rightName: '科目成绩',
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
        ],
      },
      {
        path: 'report',
        name: 'reportManage',
        component: _import('report/ReportManage'),
        meta: {
          title: 'report.manage',
          category: 'report',
          rightName: '成绩报告',
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'termPerformanceSwitch',
        },
        children: [
          // {
          //   path: 'grade/class',
          //   name: 'gradeClass',
          //   component: _import('report/GradeClass'),
          //   meta: {
          //     title: 'public.grades',
          //     category: 'report',
          //     rightName: '成绩'
          //     // icon: require('../assets/img/icon/所有机构.png')
          //   }
          // },
          // {
          //   path: 'grade/:classId',
          //   name: 'gradeClassStudent',
          //   component: _import('report/GradeClassStudent'),
          //   meta: {
          //     hidden: true,
          //     baseName: 'gradeClass',
          //     title: 'public.grades',
          //     category: 'report',
          //     rightName: '成绩'
          //     // icon: require('../assets/img/icon/所有机构.png')
          //   }
          // },
          {
            path: 'term-performance',
            name: 'termPerformanceSwitch',
            component: _import('report/TermPerformanceSwitch'),
            meta: {
              title: 'grades.regularGrades',
              category: 'report',
              rightName: '平时报告',
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
          {
            path: 'transcript',
            name: 'transcriptSwitch',
            component: _import('report/TranscriptSwitch'),
            meta: {
              title: 'public.transcript',
              category: 'report',
              rightName: '成绩单',
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
          {
            path: 'offical-transcript',
            name: 'officalTranscriptSwitch',
            component: _import('report/OfficalTranscriptSwitch'),
            meta: {
              title: 'public.officalTranscript',
              category: 'report',
              rightName: '学年成绩单',
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
          {
            path: 'score-reports',
            name: 'scoreReports',
            component: _import('report/ScoreReports'),
            meta: {
              title: 'public.scoreReports',
              category: 'report',
              rightName: '成绩权限',
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
        ],
      },
      {
        path: 'scholarship',
        name: 'scholarshipManage',
        component: _import('scholarship/ScholarshipManage'),
        meta: {
          title: 'scholarship.manage',
          category: 'scholarship',
          rightName: '奖学金管理',
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'scholarshipSwitch',
        },
        children: [
          {
            path: 'list',
            name: 'scholarshipSwitch',
            component: _import('scholarship/ScholarshipSwitch'),
            meta: {
              title: 'scholarship.scholarship',
              category: 'scholarship',
              rightName: '所有奖学金',
              // icon: require('../assets/img/icon/所有机构.png')
            },
          },
        ],
      },
      {
        path: 'home',
        name: 'home',
        component: _import('home/index'),
        meta: {
          category: 'home',
          hidden: true,
        },
      },
      {
        path: 'Statistics',
        name: 'StatisticsManage',
        component: _import('Statistics/StatisticsManage'),
        meta: {
          title: 'statistics.manage',
          category: 'statistics',
          rightName: '数据统计',
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'daily',
        },
        children: [
          {
            path: 'daily',
            name: 'daily',
            component: _import('Statistics/daily'),
            meta: {
              title: 'statistics.performace',
              category: 'statistics',
              rightName: '平时成绩',
            },
          },
          {
            path: 'quiz',
            name: 'quiz',
            component: _import('Statistics/quiz'),
            meta: {
              title: 'statistics.quiz',
              category: 'statistics',
              rightName: '小测成绩',
            },
          },
          {
            path: 'midTerm',
            name: 'midTerm',
            component: _import('Statistics/midTerm'),
            meta: {
              title: 'statistics.MidTermExam',
              category: 'statistics',
              rightName: '期中成绩',
            },
          },
          {
            path: 'finalTerm',
            name: 'finalTerm',
            component: _import('Statistics/finalTerm'),
            meta: {
              title: 'statistics.FinalTerm',
              category: 'statistics',
              rightName: '期末成绩',
            },
          },
          {
            path: 'comprehensiveResults',
            name: 'comprehensiveResults',
            component: _import('Statistics/comprehensiveResults'),
            meta: {
              title: 'statistics.ComprehensiveResults',
              category: 'statistics',
              rightName: '全年成绩',
            },
          },
        ],
      },
      {
        path: 'achievement-statistics',
        name: 'achievementStatisticsManage',
        component: _import('achievementStatistics/Manage'),
        meta: {
          title: 'statistics.overview',
          category: 'achievementStatistics',
          rightName: '数据概况',
          // icon: require('../assets/img/icon/机构管理.png'),
          // activeIcon: require('../assets/img/icon/机构管理.png')
        },
        redirect: {
          name: 'achievementStatisticsDaily',
        },
        children: [
          {
            path: 'daily',
            name: 'achievementStatisticsDaily',
            component: _import('achievementStatistics/Daily'),
            meta: {
              title: 'statistics.performace',
              category: 'achievementStatistics',
              rightName: '平时成绩',
            },
          },
          {
            path: 'quiz',
            name: 'achievementStatisticsQuiz',
            component: _import('achievementStatistics/Quiz'),
            meta: {
              title: 'statistics.quiz',
              category: 'achievementStatistics',
              rightName: '小测成绩',
            },
          },
          {
            path: 'midTerm',
            name: 'achievementStatisticsMidTerm',
            component: _import('achievementStatistics/MidTerm'),
            meta: {
              title: 'statistics.MidTermExam',
              category: 'achievementStatistics',
              rightName: '期中成绩',
            },
          },
          {
            path: 'finalTerm',
            name: 'achievementStatisticsFinalTerm',
            component: _import('achievementStatistics/FinalTerm'),
            meta: {
              title: 'statistics.FinalTerm',
              category: 'achievementStatistics',
              rightName: '期末成绩',
            },
          },
          {
            path: 'comprehensiveResults',
            name: 'achievementStatisticsComprehensiveResults',
            component: _import('achievementStatistics/ComprehensiveResults'),
            meta: {
              title: 'statistics.ComprehensiveResults',
              category: 'achievementStatistics',
              rightName: '全年成绩',
            },
          },
        ],
      },
    ],
  },
  {
    path: '*',
    redirect: '/404',
  },
]
